/**
 * @desc 财务收支应用表列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<ObjectMap>;
export function request(
  body: defs.basics.FinanceAccountRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/financeAccount/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
